<template>
  <b-modal
    ref="reinstallVpnServer"
    centered
    size="lg"
    title="Reinstall VPN server"
    hide-header-close
    footer-bg-variant=""
    scrollable
    no-close-on-esc
    @hide="onHideAttempt"
    @hidden="unselectVpnServer()">
    <b-form @submit.stop.prevent>
      <b-alert
        show
        variant="light-warning"
        class="mb-8">
        You enter all parameters at your own risk. They can affect the performance of the entire system. Be very careful when adding or changing these parameters.
      </b-alert>

      <b-form-group
        v-for="(parameter, index) in selectedVpnServer.parameters"
        :key="`dataset-${index}`"
        :class="{ 'mb-3' : index === selectedVpnServer.parameters.length - 1 }">
        <b-row>
          <b-col
            col
            lg="4"
            md="4"
            sm="3"
            cols="3"
            class="pr-2 pr-md-4">
            <b-form-input
              v-model="parameter.name"
              placeholder="Key"
              class="mb-2" />
          </b-col>
          <b-col
            col
            lg="8"
            md="8"
            sm="9"
            cols="9"
            class="d-flex pl-2 pl-md-4">
            <b-form-textarea
              v-model="parameter.code"
              rows="4"
              no-resize
              placeholder="Value" />
            <b-button
              variant="outline-primary"
              class="btn-icon ml-6"
              size="sm"
              style="min-width: calc(1.35em + 1.1rem + 2px);"
              @click="deleteParameter(index)">
              <i class="fa fa-trash fa-sm"></i>
            </b-button>
          </b-col>
        </b-row>
      </b-form-group>

      <div class="d-flex">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="addNewParameter(selectedVpnServer.parameters.length)">
          <i class="fa fa-plus fa-sm"></i>
          Add New
        </b-button>
      </div>
    </b-form>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          v-b-tooltip.hover.right
          id="cancelModal"
          title="Are you sure? Unsaved data will be lost."
          variant="outline-secondary"
          size="md"
          @click="hideModal('reinstallVpnServer')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="serversResponses('reinstallVpnServer')"
          @click="reinstallVpnServer">
          Reinstall VPN Server
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { REINSTALL_VPN_SERVER } from '@/core/services/store/servers.module'
import {
  UNSELECT_VPN_SERVER,
  ADD_NEW_VPN_SERVER_PARAM,
  DELETE_VPN_SERVER_PARAM
} from '@/core/services/store/vpn-servers.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal, onHideAttempt } from '@/core/utils'

export default {
  name: 'ModalReinstallVpnServer',
  data() {
    return {
      showModal,
      hideModal,
      onHideAttempt
    }
  },
  computed: {
    ...mapGetters([
      'selectedServer',
      'selectedServerId',
      'FailedDataGetStatus',
      'serverStatusBadge',
      'serversResponses',

      'vpnServersList',
      'vpnServersEmpty',
      'selectedVpnServer',
      'totalVpnServers',
      'vpnServerParamsLength',
      'vpnServerInstallBadge',
      'selectedVpnServerExist',
      'someVpnServerPending',
      'noneVpnServerPending',
      'installedVpnServersCount',
      'vpnServersResponses'
    ])
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectVpnServer() {
      this.$store.commit(UNSELECT_VPN_SERVER)
    },

    addNewParameter(index) {
      this.$store.commit(ADD_NEW_VPN_SERVER_PARAM, index)
    },

    deleteParameter(index) {
      this.$store.commit(DELETE_VPN_SERVER_PARAM, index)
    },

    reinstallVpnServer() {
      this.$store.dispatch(REINSTALL_VPN_SERVER, {
        vpn_code: this.selectedVpnServer.code,
        server_id: this.selectedServerId,
        payload: this.selectedVpnServer.parameters
      }).then(() => {
        this.hideModal('reinstallVpnServer')
      })
    },
  }
}
</script>
